module.exports = __webpack_public_path__ + "img/frame (54).d611f1dd.jpg";